var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "table",
    { staticClass: "details", attrs: { role: "presentation" } },
    [
      _c("tbody", [
        _c("tr", { staticClass: "mobile-hidden tablet-hidden" }, [
          _c("td", { staticClass: "sq-ft" }, [
            _vm._v(_vm._s(_vm.currentRoomSqFt) + " sq. ft."),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "bed" }, [
            _vm._v(_vm._s(_vm.currentRoomBedType)),
            _c("br"),
            _vm._v(_vm._s(_vm.currentRoomBedCount)),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "bath" }, [
            _vm._v(_vm._s(_vm.currentRoomBathCount)),
          ]),
          _vm._v(" "),
          _c(
            "td",
            { staticClass: "smoking" },
            [_c("quick-details-smoking")],
            1
          ),
          _vm._v(" "),
          false !== _vm.checkIfRoomTypeVariantExists("ROOM_ADA", true, 0)
            ? _c("td", { staticClass: "ada" }, [_c("quick-details-ada")], 1)
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("tr", { staticClass: "mobile-only tablet-only" }, [
          _c("td", { staticClass: "sq-ft", attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.currentRoomSqFt) + " sq. ft."),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "bed", attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.currentRoomBedType)),
            _c("br"),
            _vm._v(_vm._s(_vm.currentRoomBedCount)),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "bath", attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.currentRoomBathCount)),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", { staticClass: "mobile-only tablet-only" }, [
          _c(
            "td",
            { staticClass: "smoking", attrs: { colspan: "3" } },
            [_c("quick-details-smoking")],
            1
          ),
          _vm._v(" "),
          false !== _vm.checkIfRoomTypeVariantExists("ROOM_ADA", true, 0)
            ? _c(
                "td",
                { staticClass: "ada", attrs: { colspan: "3" } },
                [_c("quick-details-ada")],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }